// extracted by mini-css-extract-plugin
export default {"container":"jrXSW","item":"oWI6T"};